import { IconShieldLock, IconRefresh, IconArrowNarrowUp, IconId, IconReplace, IconDeviceMobile } from '@tabler/icons';
const icons = {
    IconShieldLock,
    IconRefresh,
    IconArrowNarrowUp,
    IconId,
    IconReplace,
    IconDeviceMobile
};

// ==============================|| Operation MENU ITEMS ||============================== //

const Operation = {
    id: 'operation',
    title: 'Operation',
    type: 'group',
    children: [
                {
                    id: 'pin-set',
                    title: 'PIN Set',
                    type: 'item',
                    url: '/contract/set/pin',
                    icon: icons.IconId,
                    breadcrumbs: false,
                },
                {
                    id: 'pin-change',
                    title: 'PIN Change',
                    type: 'item',
                    url: '/contract/change/pin',
                    icon: icons.IconReplace,
                    breadcrumbs: false
                },
                {
                    id: 'usage-limiter',
                    title: 'Usage Limiter',
                    type: 'item',
                    url: '/contract/usage-limiter',
                    icon: icons.IconRefresh     ,
                    breadcrumbs: false
                }
    ]
};

export default Operation;
